import * as Vue from "vue";
import { TippyPlugin } from "tippy.vue";
import 'tippy.js/dist/tippy.css';

export function CreateVueAppWithDirectives(rootComponent: Vue.Component<any, any, any, Vue.ComputedOptions, Vue.MethodOptions>, rootProps?: any) {
    let app = Vue.createApp(rootComponent, rootProps);

    // Enables the use of the v-tippy directive
    // https://github.com/thecodewarrior/Tippy.vue
    app.use(TippyPlugin);

    // Taken from https://stackoverflow.com/questions/36170425/detect-click-outside-element
    app.directive('click-outside', {
        mounted: function (el, binding, vnode) {
          el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
              // and if it did, call method provided in attribute value
              binding.value(event);
            }
          };
          document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unmounted: function (el) {
          document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });

    return app;
}